// extracted by mini-css-extract-plugin
module.exports = {"pixel":"GoToRefOffer_pixel__2wMwt"};